<template>
    <input
        type="text"
        v-model="valueInner"
        class="ScenarioInput"
        @focusout="focusout"
        @focusin="focusin"
        @keyup.enter="enter"
        :readonly="!isEditable"
        :placeholder="placeholder"
    >
</template>

<script>
import {mapState} from 'vuex'
import ScenarioService from '@/services/scenario.service'

export default {
    name: 'ScenarioInput',
    props: {
        value: String,
        updateOnInput: Boolean,
        editable: {
            type: Boolean,
            default: null
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            valueInner: this.value
        }
    },
    computed: {
        ...mapState({
            stateEditable: () => ScenarioService.isEditable()
        }),
        isEditable() {
            if (typeof this.editable === 'boolean') {
                return this.editable
            }
            return this.stateEditable
        }
    },
    methods: {
        focusout() {
            this.$emit('focusout', this.valueInner)
            if (!this.updateOnInput && this.valueInner !== this.value) {
                this.$emit('input', this.valueInner)
                this.$emit('save')
            }
        },
        focusin() {
            this.$emit('focusin')
        },
        input() {
            if (this.updateOnInput && this.valueInner !== this.value) {
                this.$emit('input', this.valueInner)
                this.$emit('save')
            }
        },
        enter() {
            if (!this.updateOnInput && this.valueInner !== this.value) {
                this.$emit('input', this.valueInner)
                this.$emit('save')
            }
            this.$emit('enter')
        },
        clear() {
            this.valueInner = ''
            this.$emit('input', this.valueInner)
            this.$emit('save')
        }
    },
    watch: {
        value(value) {
            this.valueInner = value
        }
    }
}
</script>

<style scoped lang="scss">
.ScenarioInput {
    line-height: 32px;
    height: 32px;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px solid #D9D9D9;
    outline: none;
    font-size: 14px;
    padding: 6px 12px;

    &:disabled {
        color: #ccc;
    }
}
</style>
